import { render, staticRenderFns } from "./QualityControlOnContactData.vue?vue&type=template&id=5b8dafca&scoped=true"
import script from "./QualityControlOnContactData.vue?vue&type=script&lang=js"
export * from "./QualityControlOnContactData.vue?vue&type=script&lang=js"
import style0 from "./QualityControlOnContactData.vue?vue&type=style&index=0&id=5b8dafca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8dafca",
  null
  
)

export default component.exports